// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-medium-text-226ee47f"};